(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("cloudinaryJsStreaming", [], factory);
	else if(typeof exports === 'object')
		exports["cloudinaryJsStreaming"] = factory();
	else
		root["cloudinaryJsStreaming"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 